import React, { useEffect, useRef, useContext, useState } from 'react';

import { ProductContext } from './Components/Context/Context';

import Navigation from './Components/Navigation/Navigation'
import {Main} from './Components/Main/Main'
import Summary from './Components/Summary/Summary'
import {getMarge} from './Components/Functions/getMarge'

import { EndScreen } from './Components/EndScreen/EndScreen';
import calculateTotals from './Components/Functions/calculateTotals';
import Tracking from './Components/Functions/tracking';

const replaceComma = (value) => {
	if(!value) return value
	return value.replace(',', '.')
}




const App = () => {

	const apiRoute = document.getElementById('nordoel_heizoel_app').dataset.pageurl
	const API_URL = `${apiRoute}/wp-json/`
	const [ settingsToConvert, setSettingsToConvert ] = useState(null)

	const {
			setProducts,
			settings,
			setSettings,
			bestellung,
			setBestellung,
			oelpreis,
			setLoading,
			region,
			setRegion,
			step,
			setStep,
			activeStep, setActiveStep,
			generalPrices, setGeneralPrices,
			setError,
			currentPlz,
	} = useContext(ProductContext)

	useEffect(() => { 
		switch (activeStep) {
			case 2:
				Tracking.setLieferUmfang(bestellung.liefermenge, bestellung.plz, bestellung.lieferfahrzeug[0], bestellung.schlauch[0])
				break;
			case 3:
				Tracking.setProduct(bestellung.totals.productName, bestellung.totals.productId, bestellung.liefermenge, bestellung.totals.allTotalNetto, bestellung.plz, bestellung.lieferfahrzeug[0], bestellung.schlauch[0])
				break;
			case 4:
				Tracking.setPayment(bestellung.totals.productName, bestellung.contact.main.payment.method , bestellung.totals.productId, bestellung.liefermenge, bestellung.totals.allTotalNetto, bestellung.plz, bestellung.lieferfahrzeug[0], bestellung.schlauch[0])
				break;
			default:
				break;
		}
		// eslint-disable-next-line
	}, [activeStep])

	// const getRegion = async (plz) => { 
	// 	const bereich = await fetch(`${API_URL}postleitzahlen/plz?id=${plz}`)
	// 	return bereich
	// }
	
	const getPlzData = async (plz) => {

		if (plz.length < 5 || plz.length > 5) return setError(prev => 'Bitte geben Sie eine gültige Postleitzahl ein.')
	
		setLoading(true)
		
		
	
		const bereich = await fetch(`${API_URL}postleitzahlen/plz?id=${plz}`)
			.then(res => {
				return res.json()
			}).catch(err => console.log(err))
	
		if (bereich.length) {

			setRegion(prev => { 
				return {
					region: Object.values(bereich[0])[0].region,
					slug: Object.values(bereich[0])[0].slug,
					aufpreis: Object.values(bereich[0])[0].aufpreis,
					id: Object.values(bereich[0])[0].id,
				}
			})
			// Wenn Region gefunden Eintstellungen laden
			await fetch(`${API_URL}wp/v2/heizoel-settings?slug=${Object.values(bereich[0])[0].slug}`)
				.then(res => res.json())
				.then(data => setSettingsToConvert(data))
				.catch(err => console.error('=== SETTINGS-ERROR === ', err))
			
			// console.log(settings)
		
			setError(prev => false)

			
		} else { 
			setLoading(prev => false)
			setError(prev => 'Bitte haben Sie Verständnis dafür, dass wir in der von Ihnen angegebenen Region leider keine Lieferung vornehmen können. Für Rückfragen kontaktieren Sie uns gerne.')
		}
	
	
	
		
		// Wenn Region gefunden Produkte laden
		
		
	
		setLoading(false)
	}
	
	const firstPlzUpdate = useRef(true)

	useEffect(() => { 
		if (firstPlzUpdate.current) {
			firstPlzUpdate.current = false
			return
		}
		if (currentPlz.length > 4 && currentPlz.length < 6) {
			getPlzData(currentPlz)
			setBestellung(prev => ({ 
				...prev,
				plz: currentPlz
			}))
		}
		// eslint-disable-next-line 
	 }, [currentPlz])
	
	useEffect(() => {
		window.scrollTo({
		  top: 0,
		  behavior: "smooth",
		});
	}, [step]);

	const getProductList = async () => { 
		const productList = await fetch(`${API_URL}wp/v2/heizoelproduct?per_page=100&filter[orderby]=date&order=asc&bereiche=${region.id}`)
		.then(res => res.json())
			.catch(err => console.error('=== PRODUCT-ERROR === ', err))
		// console.log('PL: ', productList)
		setProducts(prev => productList)
		return productList
	}
	

	useEffect(() => {
		if (region.id) {
			// console.log("=== PRODUCT UPDATE ===", region)
			getProductList()
			settingsToConvert && convertSettings(settingsToConvert)
			setSettingsToConvert(null)
		}
		
		// eslint-disable-next-line 
	}, [region]) 
	
	

	useEffect(() => {
		if (settingsToConvert) {
			convertSettings(settingsToConvert)
			setSettingsToConvert(null)
		}
		
		// eslint-disable-next-line 
	}, [settingsToConvert]) 
	
	// console.log(region, settings);


	//Settings in State laden


	const convertSettings = (settings) => {

		console.log(currentPlz, region);

		if (region.region === "") {
			
			//const bereich = getRegion(currentPlz).then(res => res.json())
			// console.log(bereich)
		}

			// console.log(settings, region);
			settings.map(data => {

				let aufpreis = 0
				if (data.acf.liefergebiete) {
					data.acf.liefergebiete.map(l => {
						if (l.lg_plz === bestellung.plz) { 
							console.log(l.lg_plz, bestellung.plz)
							aufpreis = parseFloat(l.aufpreis_liefergebiet)
							console.log("Aufschlag PLZ: ", aufpreis, l)
						}
						return aufpreis
					})
				}

				setBestellung(prev => ({
					...prev,
					settings: {
						...prev.settings,
						aufschlag_lieferstelle: parseFloat(data.acf.lieferzeiten_lieferstelle.replace(',', '.')),
						aufschlag_wunschtermin: parseFloat(data.acf.lieferzeiten_wunschtermin.replace(',', '.')),
						kwk: data.acf.no_kwk.length > 0,
						gewinnspiel: data.acf.gewinnspiel ? data.acf.text_gewinnspiel : false,
						vorfracht: parseFloat(data.acf.vorfracht),
						lieferzeit_max: data.acf.lieferzeiten_max,
						ggvs: parseFloat(replaceComma(data.acf.ggvs)),

					},
					totals: {
						...prev.totals,
						ggvs: parseFloat(replaceComma(data.acf.ggvs)),
					},
					telefon: data.acf.kontakt_phone,
					email: data.acf.kontakt_email,
					aufpreis,
					basePrice: oelpreis
				}))

				setGeneralPrices({
					wunschtermin: parseFloat(data.acf.lieferzeiten_wunschtermin.replace(',', '.')),
					lieferstelle: parseFloat(data.acf.lieferzeiten_lieferstelle.replace(',', '.'))
				})

			
				return setSettings((prev) => ({

					...prev,
					[data.title.rendered]: {
						margen: data.acf.margentabelle,
						lieferung: data.acf.lieferzeiten,
						liefertermine: data.acf.liefertermine,
						ggvs: data.acf.ggvs,
						schnelleLieferung: data.acf.kurze_lieferzeiten,
						termin: data.acf.no_liefetermin.length === 1 ? false : true,
						schlauch: data.acf.schlauchlange,
						ohneHaenger: data.acf.ohne_anhanger,
						bezahlung: data.acf.ec_karte,
						aufschlag_lieferstelle: parseFloat(data.acf.lieferzeiten_lieferstelle.replace(',', '.')),
						wunschtermin: parseFloat(data.acf.lieferzeiten_wunschtermin.replace(',', '.')),
						kwk: data.acf.no_kwk.length > 0,
						gewinnspiel: data.acf.gewinnspiel ? data.acf.text_gewinnspiel : false,
						telefon: data.acf.kontakt_phone,
						email: data.acf.kontakt_email,
						vorfracht: parseFloat(data.acf.vorfracht),
						aufpreisZahlung: {
							ec: data.acf.ec_aufpreis || 0,
							bar: data.acf.bar_aufpreis || 0,
							rechnung: data.acf.aufpreis_rechnung || 0,
							garantie: data.acf.aufpreis_garantiere_zahlung || 0,
							vorkasse: data.acf.aufpreis_vorkasse || 0,
							lastschrift: data.acf.aufpreis_lastschrift || 0,

						}
					}
				})
				)
			})
		
		

}

	




	const nextStep = () => {
		if (step === activeStep) {
			setActiveStep( step + 1 )
		}
		setStep(prev => prev + 1)
	}

	const setStepHandler = (s) => { 
		
		if (s === -1) {
			setStep(prev => prev - 1)

		} else { 

			if (step === activeStep) {
				setActiveStep(step + 1)
				setStep(step + 1)
			}

			if (step < activeStep) { 
				setStep(step + 1)
			}
		}
		
	}


	const setActivatedStep = (s) => {
		if (s <= activeStep) { 
			setStep(s)
		}
	}

	
	useEffect(() => {

		setBestellung({
			...bestellung,
			totals: {
				...bestellung.totals,
				allTotalNetto: calculateTotals(bestellung.totals, bestellung.anzahlLieferstellen)
			}
		})
		getMarge(region, settings, bestellung, setBestellung);

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		bestellung.totals.express,
		bestellung.totals.schlauch,
		bestellung.totals.lieferstelle,
		bestellung.totals.termin,
		bestellung.totals.wunschtermin,
		bestellung.totals.lieferfahrzeug,
		bestellung.totals.totalNetto,
		bestellung.totals.per100Netto,
		step
	])


	return (
		<>
			{step < 5 ?
			<><Navigation
				current={step}
				setStep={setActivatedStep}
			/>
			<Main
				plzSearch={getPlzData}
				next={nextStep}
				api={apiRoute}
				setStep={setStepHandler}
				path={apiRoute}
			/>
				
			<Summary
				bestellung={bestellung}
				settings={settings}
				setBestellung={setBestellung}
				generalPrices={generalPrices}
				setStep={setStep}
				step={step}
				region={region}
				
			/>
		</>
		:
		<EndScreen
			email={bestellung.contact.main.email}
			tel={settings[region.region].telefon}
			responsemail={settings[region.region].email}
			reset={setBestellung}
		/>
		}
		</>
	);
}

export default App;
